import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f3a0694&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7f3a0694&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3a0694')) {
      api.createRecord('7f3a0694', component.options)
    } else {
      api.reload('7f3a0694', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f3a0694&lang=pug", function () {
      api.rerender('7f3a0694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/consultants/index.vue"
export default component.exports